import { render, staticRenderFns } from "./createWxFuwuOrder.vue?vue&type=template&id=9c21b2e2&scoped=true"
import script from "./createWxFuwuOrder.vue?vue&type=script&lang=js"
export * from "./createWxFuwuOrder.vue?vue&type=script&lang=js"
import style0 from "./createWxFuwuOrder.vue?vue&type=style&index=0&id=9c21b2e2&prod&scoped=true&lang=css"
import style1 from "./createWxFuwuOrder.vue?vue&type=style&index=1&id=9c21b2e2&prod&lang=css"
import style2 from "./createWxFuwuOrder.vue?vue&type=style&index=2&id=9c21b2e2&prod&scoped=true&lang=scss"
import style3 from "./createWxFuwuOrder.vue?vue&type=style&index=3&id=9c21b2e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c21b2e2",
  null
  
)

export default component.exports